export const breakpoints = {
  default: 0,
  small: 480,
  medium: 768,
  large: 1024,
  xlarge: 1280,
  full: 1600,
};

export const breakpointsNames = Object.keys(breakpoints);

export const breakpointsMediaQueries = Object.fromEntries(
  Object.entries(breakpoints).map(([bpName, bpVal]) => [
    bpName,
    window.matchMedia(`(min-width: ${bpVal}px)`),
  ]),
);



// WEBPACK FOOTER //
// ./src/scripts/modules/breakpoints.js